import useProductData from '../context/useProductData';
import EfProductMultiSpec from '@elem/ui/ef-product-multi-spec';
import { formatMultiSpecData } from 'elem/utils/formatMultiSpecData';
import { useState } from 'react';
import ProductNav from '../overview/ProductNav';
import { theme } from '../config';
import css from './index.module.scss';

export default function TabSpecs() {
    const { data }: any = useProductData();
    const { productCatagory = null, productSeries = [] } = data;
    const [activeTab, setActiveTab] = useState('Specs');
    const tabCallback = (tabValue: string) => {
        setActiveTab(tabValue);
    };

    return (
        <div className={css.specs}>
            <ProductNav activeTab={activeTab} tabCallback={tabCallback} />
            {productCatagory && productSeries?.length > 0 && (
                <EfProductMultiSpec items={[...productSeries]} catagories={formatMultiSpecData(productCatagory, [...productSeries])} theme={theme} />
            )}
        </div>
    );
}
